var _rect, _rect2, _rect3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    transform: "translate(-583 -623)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 960,
    transform: "translate(-583 -623)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_36229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.5 -12C-31.5 -16.4183 -27.9183 -20 -23.5 -20H111.5C115.918 -20 119.5 -16.4183 119.5 -12V28C119.5 32.4183 115.918 36 111.5 36H-23.5C-27.9183 36 -31.5 32.4183 -31.5 28V-12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8H1.5M1.5 8L8.5 15M1.5 8L8.5 1",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5 -19H111.5V-21H-23.5V-19ZM118.5 -12V28H120.5V-12H118.5ZM111.5 35H-23.5V37H111.5V35ZM-30.5 28V-12H-32.5V28H-30.5ZM-23.5 35C-27.366 35 -30.5 31.866 -30.5 28H-32.5C-32.5 32.9706 -28.4706 37 -23.5 37V35ZM118.5 28C118.5 31.866 115.366 35 111.5 35V37C116.471 37 120.5 32.9706 120.5 28H118.5ZM111.5 -19C115.366 -19 118.5 -15.866 118.5 -12H120.5C120.5 -16.9706 116.471 -21 111.5 -21V-19ZM-23.5 -21C-28.4706 -21 -32.5 -16.9706 -32.5 -12H-30.5C-30.5 -15.866 -27.366 -19 -23.5 -19V-21Z",
    fill: "#D0D5DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_36229",
    x: -33.5,
    y: -21,
    width: 155,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_36229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_36229",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default "data:image/svg+xml,%3csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='17' height='16' fill='%23E5E5E5'/%3e %3crect width='1440' height='960' transform='translate(-583 -623)' fill='white'/%3e %3crect width='1440' height='960' transform='translate(-583 -623)' fill='white'/%3e %3cg filter='url(%23filter0_d_204_36229)'%3e %3cpath d='M-31.5 -12C-31.5 -16.4183 -27.9183 -20 -23.5 -20H111.5C115.918 -20 119.5 -16.4183 119.5 -12V28C119.5 32.4183 115.918 36 111.5 36H-23.5C-27.9183 36 -31.5 32.4183 -31.5 28V-12Z' fill='white'/%3e %3cpath d='M15.5 8H1.5M1.5 8L8.5 15M1.5 8L8.5 1' stroke='%23344054' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e %3cpath d='M-23.5 -19H111.5V-21H-23.5V-19ZM118.5 -12V28H120.5V-12H118.5ZM111.5 35H-23.5V37H111.5V35ZM-30.5 28V-12H-32.5V28H-30.5ZM-23.5 35C-27.366 35 -30.5 31.866 -30.5 28H-32.5C-32.5 32.9706 -28.4706 37 -23.5 37V35ZM118.5 28C118.5 31.866 115.366 35 111.5 35V37C116.471 37 120.5 32.9706 120.5 28H118.5ZM111.5 -19C115.366 -19 118.5 -15.866 118.5 -12H120.5C120.5 -16.9706 116.471 -21 111.5 -21V-19ZM-23.5 -21C-28.4706 -21 -32.5 -16.9706 -32.5 -12H-30.5C-30.5 -15.866 -27.366 -19 -23.5 -19V-21Z' fill='%23D0D5DD'/%3e %3c/g%3e %3cdefs%3e %3cfilter id='filter0_d_204_36229' x='-33.5' y='-21' width='155' height='60' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e %3cfeOffset dy='1'/%3e %3cfeGaussianBlur stdDeviation='1'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_204_36229'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_204_36229' result='shape'/%3e %3c/filter%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };